import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';

class Lazyload {
	constructor() {
		this.init();
	}

	init() {
		function logElementEvent(eventName, element) {
			//console.log(Date.now(), eventName, element.getAttribute("data-src"));
		}

		var callback_enter = function (element) {
			logElementEvent('🔑 ENTERED', element);
		};
		var callback_exit = function (element) {
			logElementEvent('🚪 EXITED', element);
		};
		var callback_loading = function (element) {
			logElementEvent('⌚ LOADING', element);
		};
		var callback_loaded = function (element) {
			logElementEvent('👍 LOADED', element);
		};
		var callback_error = function (element) {
			logElementEvent('💀 ERROR', element);
			element.src =
				'https://via.placeholder.com/440x560/?text=Error+Placeholder';
		};
		var callback_cancel = function (element) {
			logElementEvent('🔥 CANCEL', element);
		};
		var callback_finish = function () {
			logElementEvent('✔️ FINISHED', document.documentElement);
		};

		var options = {
			// Assign the callbacks defined above
			callback_enter: callback_enter,
			callback_exit: callback_exit,
			callback_cancel: callback_cancel,
			callback_loading: callback_loading,
			callback_loaded: callback_loaded,
			callback_error: callback_error,
			callback_finish: callback_finish,
		};

		var page_ll = new LazyLoad(options);

		function mouseoverHandler(event) {
			var product = event.currentTarget;
			var lazyImg = product.querySelector('.card__img_back img');
			if (!!lazyImg.getAttribute('data-ll-status')) {
				return;
			}
			page_ll.load(lazyImg);
			LazyLoad.load(lazyImg, options);
		}

		function nodeSetToArray(nodeSet) {
			return Array.prototype.slice.call(nodeSet);
		}

		function initializeMouseBehaviour() {
			const products = document.querySelectorAll('.card');
			nodeSetToArray(products).forEach(function (product) {
				product.addEventListener('mouseover', mouseoverHandler, true);
			});
		}

		initializeMouseBehaviour();
	}
}

export default Lazyload;
